import {combineReducers} from '@reduxjs/toolkit';
import {instrumentsSlice} from '../instruments';
import {itemsSlice} from '../items/store';

export const libraryReducer = combineReducers({
  instruments: instrumentsSlice.reducer,
  items: itemsSlice.reducer,
});
